import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconSparkle = (props: IconProps) => (
  <svg
    width={props.width || "19"}
    height={props.height || "19"}
    viewBox="-0.334 -0.334 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", margin: "0 auto" }}
    {...props}
  >
    <path
      d="M15 0L13.95 2.29167L11.6667 3.33333L13.95 4.38333L15 6.66667L16.0417 4.38333L18.3333 3.33333L16.0417 2.29167M6.66667 2.5L4.58333 7.08333L0 9.16667L4.58333 11.25L6.66667 15.8333L8.75 11.25L13.3333 9.16667L8.75 7.08333M15 11.6667L13.95 13.95L11.6667 15L13.95 16.0417L15 18.3333L16.0417 16.0417L18.3333 15L16.0417 13.95"
      fill={props.color || colors.secondaryAction.default}
    />
  </svg>
);

export default IconSparkle;
